"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdiabasTimeoutError = exports.SimulationInterface = exports.EdiabasInterface = void 0;
var EdiabasInterface_1 = require("./EdiabasInterface");
Object.defineProperty(exports, "EdiabasInterface", { enumerable: true, get: function () { return EdiabasInterface_1.EdiabasInterface; } });
var SimulationInterface_1 = require("./SimulationInterface");
Object.defineProperty(exports, "SimulationInterface", { enumerable: true, get: function () { return SimulationInterface_1.SimulationInterface; } });
Object.defineProperty(exports, "EdiabasTimeoutError", { enumerable: true, get: function () { return SimulationInterface_1.EdiabasTimeoutError; } });
//# sourceMappingURL=index.js.map